import { render, staticRenderFns } from "./SideTagsSubtaskSubDialog.vue?vue&type=template&id=4b49853a&scoped=true&"
import script from "./SideTagsSubtaskSubDialog.vue?vue&type=script&lang=js&"
export * from "./SideTagsSubtaskSubDialog.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsSubtaskSubDialog.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SideTagsSubtaskSubDialog.vue?vue&type=style&index=1&id=4b49853a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49853a",
  null
  
)

export default component.exports